module.exports = __webpack_public_path__ + "img/second-2.122bbe88.webp";